import * as S from "../TaskCardFirstSteps/taskCardContentsFirstSteps.styles";
import { ReactComponent as IconLeft } from "../../../../styles/assets/svg/icon-left-arrow.svg";
import { ReactComponent as IconRight } from "../../../../styles/assets/svg/icon-right-arrow.svg";
import { ReactComponent as IconCheckTrue } from "../../../../styles/assets/svg/icon-checkbox-check-primary.svg";
import { ReactComponent as IconCheckFalse } from "../../../../styles/assets/svg/icon-checkbox-none-gray.svg";
import { ReactComponent as IconCameraWhite } from "../../../../styles/assets/svg/icon-camera-white.svg";
import { TransportationType } from "../../../../interface/transportation";
import dayjs from "dayjs";
import { useEffect } from "react";
import { ReactComponent as IconReceipt } from "../../../../styles/assets/svg/icon-receipt.svg";
interface TaskCardContentFourProps {
  workCompletedData: TransportationType;
  handleNextButtonClick: () => void;
  handleBackBtnClick: () => void;
  setIsNextLevel: React.Dispatch<React.SetStateAction<number>>;
  setIsImgCheck: React.Dispatch<React.SetStateAction<boolean>>;
  setIsErrorCheck: React.Dispatch<React.SetStateAction<boolean>>;
  onImageRegisterPageMove: () => void;
  onInvoiceImageRegisterPageMove?: () => void;
  isImgCheck: boolean;
  isErrorCheck: boolean;
}

export const TaskCardContentsFourSteps = ({
  workCompletedData,
  handleNextButtonClick,
  handleBackBtnClick,
  onImageRegisterPageMove,
  onInvoiceImageRegisterPageMove,
  isImgCheck,
  isErrorCheck,
  setIsImgCheck,
  setIsErrorCheck,
}: TaskCardContentFourProps) => {
  useEffect(() => {
    if (workCompletedData) {
      setIsErrorCheck(workCompletedData.work_point_completed || false);
      setIsImgCheck(workCompletedData.work_point_img_completed || false);
    }
  }, [workCompletedData]);

  return (
    <S.TaskBox>
      <S.TaskTotalWrapContainer>
        {workCompletedData?.transport_type === 1 && (
          <S.TaskTotalWrap onClick={onInvoiceImageRegisterPageMove}>
            <IconReceipt width={25} height={25} /> 인수증
          </S.TaskTotalWrap>
        )}
        <S.TaskTotalWrap onClick={onImageRegisterPageMove}>
          <IconCameraWhite width={25} height={25} /> 사진등록
        </S.TaskTotalWrap>
      </S.TaskTotalWrapContainer>
      <S.TaskContainer>
        <S.TaskContent>
          <S.TaskHeadBox>
            <S.Sbox>
              <S.StepBox>4 / 6단계</S.StepBox>
              <S.StateBox>작업완료</S.StateBox>
            </S.Sbox>
            <S.DateBox>
              {dayjs(new Date()).format("YYYY-MM-DD HH:mm")}
            </S.DateBox>
          </S.TaskHeadBox>
          <S.ProgressBar progress="72%" />
          <S.CheckBoxGroup>
            <S.TaskCardCheckBox
              onClick={() => setIsImgCheck(!isImgCheck)}
              className={isImgCheck ? "checked" : ""}
              divGap="6px"
            >
              {isImgCheck ? (
                <IconCheckTrue width={25} height={25} />
              ) : (
                <IconCheckFalse width={25} height={25} />
              )}
              <p>필요한 사진등록을 완료했습니다.</p>
            </S.TaskCardCheckBox>
            <S.TaskCardCheckBox
              onClick={() => setIsErrorCheck(!isErrorCheck)}
              className={isErrorCheck ? "checked" : ""}
              divGap="6px"
            >
              {isErrorCheck ? (
                <IconCheckTrue width={25} height={25} />
              ) : (
                <IconCheckFalse width={25} height={25} />
              )}
              <p>컨테이너에 이상이 없습니다.</p>
            </S.TaskCardCheckBox>
          </S.CheckBoxGroup>
        </S.TaskContent>

        <S.ButtonBox>
          <S.Button width="60%" color="white" onClick={handleBackBtnClick}>
            <IconLeft width={20} height={20} />
            <S.BText>이전</S.BText>
          </S.Button>
          <S.Button
            width="100%"
            color="primary"
            isErrorCheck={isErrorCheck}
            onClick={handleNextButtonClick}
            disabled={!isErrorCheck}
          >
            <S.BText>다음</S.BText>
            <IconRight width={20} height={20} />
          </S.Button>
        </S.ButtonBox>
      </S.TaskContainer>
    </S.TaskBox>
  );
};
export default TaskCardContentsFourSteps;
